import queryString from 'querystring';
import { showToast } from '@turingshequ/react-toast/src'
import redirectLogin from './redirectLogin'
import { MsgType } from 'components/MessageCard'

function resolve(path: string) {
  let host = process.env.NEXT_PUBLIC_API_HOST as string
  if (typeof location !== 'undefined') {
    host = host.replace(/^https?:/, location.protocol)
  }
  return host + (path || '')
}

const WORKS_LIST_URL = resolve('api/index/works/list')
const MY_WORKS_LIST_URL = resolve('api/user/works/list')
const MESSAGE_LIST = resolve('api/user/message/list')
const WORK_SAVE = resolve('api/works/save')
const WORK_DETAIL = resolve('api/works/detail')
const MORE_WORK = resolve('api/user/more_works/list')
const UNREAD_COUNT = resolve('api/user/not_read/message/count')
const LIKE_API = resolve('api/works/like')
const READ_MSG = resolve('api/user/message/read')
const RELEASE = resolve('api/works/publish')
const DELETE = resolve('api/works/delete')
const DRAFT = resolve('api/works/detail/cache')
const HOME_DATA_URL = resolve('api/index/home')
const HOME_POPUPS_URL = resolve('api/index/popups/list?type=1')
const LOGOUT = (typeof location !== 'undefined' ? location.protocol : 'https:') + '//dict.youdao.com/login/acc/se/reset?product=DICT&app=ke&version=2.0&api_ver=1.10.0&api_version=1.2&newjson=true'

export function logoutReq() {
  return fetchProxy(LOGOUT).then(() => {
    location.reload()
  }, () => {
    alert('退出登录失败')
  })
}

export function isNotLogin(err: any) {
  if (err && err.sign == 'NEEDLOGIN') {
    return true
  }
  return false
}


export function fetchProxy<R>(url: string, config?: any): Promise<R> {
  const isMock = process.env.NEXT_PUBLIC_MOCK === 'MOCK';
  return fetch(url, { credentials: 'include', ...config }).then(res => res.json()).then((ret: any) => {
    if (ret.code != 0 && !isMock) {
      if (ret.code == 1) {
        // window.location =
        const err = new Error('need login');
        (err as any).sign = 'NEEDLOGIN';
        (err as any).ret = ret
        throw err
      }
      if (ret.code == -1) {
        if (ret.description === '正在处理中') {
          ret.description = '操作过于频繁，请稍后再试试～'
        }
      }
      if(ret.code === 2) {
        showToast({
          type: 'error',
          message: ret?.msg || ret?.description || '网络出现问题请稍后重试~'
        })
      }
      const err = new Error();
      (err as any).sign = 'UNCLASSIFIED';
      (err as any).ret = ret
      throw err
    }

    return ret
  })
}

export interface GetWorkListProps {
  page: number;
  size?: number;
  sortType: string;
  theme?: string;
  codeLanguage?: string;
  keyword?: string;
}

export interface workDataProps {
  id: string,
  title: string,
  imgUrl: string,
  likeNum: number,
  browseNum: number,
  userName: string
}

export function getWorkList(opts: GetWorkListProps) {
  const { page, size = 20, sortType, theme = 'all', codeLanguage = 'all', keyword } = opts
  const search = new URLSearchParams()
  search.set('page', String(page))
  search.set('size', String(size))
  search.set('sortType', sortType)
  search.set('theme', theme)
  search.set('codeLanguage', codeLanguage)
  if(keyword) {
    search.set('keyword', keyword)
  }
  return fetchProxy(`${WORKS_LIST_URL}?${search.toString()}`).then((ret: any) => {
    return {
      list: (Array.isArray(ret.dataList) ? ret.dataList : []) as (workDataProps)[],
      total: ret.totalCount as number
    }
  })
}

/**
 * @interface status 发布状态 0 1 2
 *
 */
export interface GetMyWorkListProps {
  page: number;
  size?: number;
  status: number;
  theme: string;
  codeLanguage: string;
  keyword: string | undefined ;
}

export function getMyWorkList(opts: GetMyWorkListProps, headers = {}) {

  return fetchProxy(`${MY_WORKS_LIST_URL}?${queryString.stringify({...opts})}`, {
    headers
  }).then((ret: any) => {
    return {
      list: (Array.isArray(ret.dataList) ? ret.dataList : []),
      total: ret.totalCount as number,
      user: ret.user,
    }
  }, (err) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

export interface MessageListOpts {
  page: number
}

export interface MessageListItem {
  actionUserId: string
  actionUserImage: string
  actionUserName: string
  createTimeStr: string
  haveRead: number
  id: number
  type: MsgType
  worksId: number
  worksTitle: string
  reportedUserId?: string
  reportedUserName?: string
}

type Indexed = {
  [K in keyof any]: any
}

export interface MessageAPI extends Indexed {
  list: MessageListItem[]
}

export class MessageList {
  static _cachedPromise: { [page: number]: { promise: Promise<MessageAPI>, timestamp: number } } = {}
  static getMessageListByPage(opts: MessageListOpts) {
    const { page } = opts
    if (this._cachedPromise[page]) {
      if (Date.now() - this._cachedPromise[page].timestamp < 5000) {
        return this._cachedPromise[page].promise
      }
    }
    this._cachedPromise[page] = {
      promise: getMessageList(opts),
      timestamp: Date.now()
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this._cachedPromise[page].promise.then(() => { }, () => {
      delete this._cachedPromise[page]
    })
    return this._cachedPromise[page].promise
  }
}

MessageList.getMessageListByPage = MessageList.getMessageListByPage.bind(MessageList)

export function getMessageList(props: MessageListOpts) {
  const { page } = props
  const search = new URLSearchParams()
  search.set('page', String(page))
  return fetchProxy(`${MESSAGE_LIST}?${search.toString()}`).then((ret: any) => {
    return {
      list: (Array.isArray(ret.dataList) ? ret.dataList : []),
      total: ret.totalCount as number
    }
  }, (err) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

export interface WorkSaveOpts {
  id: string
  title: string
  description: string
  imgUrl: string
  code: string
  type: number
  forkId: string
}

export function saveWork(opts: Partial<WorkSaveOpts>) {
  const sendObj = filterObj(opts)
  return fetchProxy<{ data: number }>(`${WORK_SAVE}`, {
    method: 'POST',
    headers: {
      ['Content-Type']: 'application/json'
    },
    body: JSON.stringify(sendObj),
  }).then(ret => {
    return (ret as any).data
  }, (err) => {
    localStorage.setItem('__SAVE_FAILED_CODE__', String(opts.code))
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

export interface GetWorkDetailOptions {
  id: string
  addBrowseNum?: boolean
}

export enum EnshrineType {
   yes = 1,
   no = 0
}
export interface WorkDetailRet {
  browseNum: number
  code: string
  createTime: string
  createTimeStr: string
  description: string
  id: string
  title: string
  type: number
  userId: string
  userImage: string
  userName: string
  imgUrl: string
  likeNum: number
  haveLiked: number
  shortLink: string
  iframeUrl: string
  firstPopups: number
  codeLanguage: string
  subTheme: string
  enshrineNum: number
  haveEnshrined: EnshrineType
  isFirstPublish: boolean,
  updateTimeStr: string,
  haveReported: number
}

export function getWorkDetail(opts: GetWorkDetailOptions) {
  const search = new URLSearchParams()
  search.set('id', String(opts.id))
  if(opts.addBrowseNum === false) {
    search.set('addBrowseNum', String(opts.addBrowseNum))
  }
  return fetchProxy(`${WORK_DETAIL}?${search.toString()}`).then((ret) => {
    return ret as { data: WorkDetailRet }
  })
}

export function getMoreWork(userId: string, currentWorksId?: string) {
  const search = new URLSearchParams()
  search.set('userId', userId)
  search.set('currentWorksId', currentWorksId || '')
  return fetchProxy(`${MORE_WORK}?${search.toString()}`).then((ret: any) => {
    return {
      list: (Array.isArray(ret.dataList) ? ret.dataList : []) as (workDataProps)[],
      total: ret.totalCount as number
    }
  })
}

export function getDraftWorkDetail(opts: GetWorkDetailOptions) {
  const search = new URLSearchParams()
  search.set('id', String(opts.id))
  return fetchProxy(`${DRAFT}?${search.toString()}`).then((ret) => {
    return ret as { data: WorkDetailRet }
  })
}


export interface UserData {
  userId: string
  userImage: string
  userName: string
}

export interface IUnread {
  code: number;
  data: {
    count: number
    messageList: Array<MessageListItem>
  };
  msg: string;
  user: {
    image: string;
    mobile: string;
    name: string;
    userId: string;
  }
}

export function getUserInfo(): Promise<UserData> {
  const promise = getUnreadDetail()
  return promise.then((ret) => {
    return {
      userId: ret.user.userId,
      userImage: ret.user.image,
      userName: ret.user.name
    }
  })
}

export function getUserInfoServer(headers: any) {
  const ret = getUnreadDetailInternal(headers).then(ret => {
    return {
      userId: ret.user.userId,
      userImage: ret.user.image,
      userName: ret.user.name
    }
  })
  return ret
}

function getUnreadDetailInternal(extraHeaders = {}) {
  const ret = fetchProxy<IUnread>(UNREAD_COUNT, {
    headers: {
      ...extraHeaders
    }
  })
  return ret
}

export function getUnreadDetail() {
  return getUnreadDetailInternal()
}

export interface Like {
  id: string
  type: number
}
export function like({ id, type }: Like) {
  const search = new URLSearchParams()
  search.set('id', String(id))
  search.set('type', String(type))
  return fetchProxy(`${LIKE_API}?${search.toString()}`, {
    method: 'POST',
  }).then((ret) => {
    return ret
  }, (err) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}




type SubTypeByValueTypeNotAllowed<T, NotAllowed> = {
  [K2 in { [K1 in keyof T]: T[K1] extends NotAllowed ? never : K1 }[keyof T]]: T[K2]
}


function filterObj<T extends { [K in keyof any]: any }>(opts: T) {
  return Object.keys(opts).reduce((a: any, b) => {
    if (opts[b] != null) {
      a[b] = opts[b]
    }
    return a
  }, {}) as SubTypeByValueTypeNotAllowed<T, null | undefined>
}

export interface ReadMessageProps {
  id: number
}

export function markReadMessage(props: ReadMessageProps) {
  const search = new URLSearchParams()
  search.set('id', String(props.id))
  return fetchProxy(`${READ_MSG}?${search.toString()}`, {
    method: 'PUT',
  }).then(ret => {
    return ret
  }, (err) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

export interface ReleaseWorkProps {
  id: string,
  title: string,
  description: string,
  imgUrl: string,
  code: string,
  type: number
  publishType: number
}

export function releaseWork({ publishType, ...props }: Partial<ReleaseWorkProps>) {
  const search = new URLSearchParams()
  search.set('publishType', String(publishType))

  return fetchProxy(`${RELEASE}?${search.toString()}`, {
    method: 'POST',
    body: JSON.stringify(props),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(ret => (ret as any).data as string, (err) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

export interface DeleteWork {
  id: string
}
export function deleteWork(props: DeleteWork) {
  const search = new URLSearchParams()
  search.set('id', String(props.id))
  return fetchProxy(`${DELETE}?${search.toString()}`, {
    method: 'DELETE',
  }).then(ret => ret, (err) => {
    if (isNotLogin(err)) {
      redirectLogin()
    }
    throw err
  })
}

export function getHomeData() {
  return fetchProxy(HOME_DATA_URL).then((ret: any) => {
    return ret?.data || null
  },(err) => {
    throw err
  })
}

export function getPopupData() {
  return fetchProxy(HOME_POPUPS_URL).then(
    (ret: any) => {
      return ret?.dataList || null
    },
    (err) => {
      throw err
    }
  )
}
